// extracted by mini-css-extract-plugin
export default {"slider__con":"styles_slider__con__GsOni"};